import { t } from "../i18n";
import { Component, type ErrorInfo, type ReactNode } from "react";
import { diagnostics } from "../diagnostics";

type Props = { children: ReactNode };
type State = { failed: boolean };

export class DiagnosticsErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    /* Error messages, component stacks and props can contain customer-entered text. The event is
       sufficient to correlate the crash with preceding safe breadcrumbs and the exact build. */
    diagnostics.record({
      name: "app.error",
      category: "UI",
      severity: "CRITICAL",
      outcome: "failed",
      metadata: {
        source: "react_boundary",
        operation: "render_error",
        error_kind: "ReactRenderError",
        fingerprint: "react_boundary"
      }
    });
  }

  render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="loading-screen" role="alert">
          <img src="/icons/icon-192.png" alt="" />
          <strong>EasyOrders</strong>
          <span>{t("Παρουσιάστηκε σφάλμα στην εφαρμογή.")}</span>
          <button type="button" className="primary-command" onClick={() => window.location.reload()}>{t("Επαναφόρτωση")}</button>
        </main>
      );
    }
    return this.props.children;
  }
}
